class LandingSubscription extends HTMLElement {
  constructor() {
    super()

    this.stepBlocks = this.querySelectorAll('[data-step]')
    this.stepInputs = this.querySelectorAll('.step-block__choice')
    this.productBlock = this.querySelector('.landing-product__final')
    this.addButtons = this.querySelectorAll('.final-step__product__button')
    this.customFrequency = this.querySelector('.step-block__item--frequency-custom');
    this.customFrequencyButtons = this.querySelectorAll('.frequency-custom__button');
    this.clickedBlock = null
    this.isProductVisible = false
    this.productType = null
    this.selectedProduct = null
    this.productsObject = JSON.parse(this.querySelector('#landing-product__object').innerHTML)
    this.layout = this.getAttribute('data-layout');
    this.stepsProgress = this.querySelector('.landing-product__steps-progress');
    this.purchaseType = this.getAttribute('data-purchase-type') || 'subscription';

    this.clearCart()

    this.stepBlocks.forEach(block => {
      if (this.dataset.layout === 'quiz'
          && block.dataset.step === "4"
          && block.classList.contains('step-block__item--frequency-custom')) {
        this.querySelector('.step-block__apply-button')?.addEventListener('click', (event) => {
          this.clickedBlock = block
          this.previousStepButton?.classList.add('active');
          this.highlightBlock(event);
        })
      }

      block.addEventListener('click', (event) => {
        if (event.target.classList.contains('step-block__choice') && event.detail === 0) {
          return
        }

        if (block.classList.contains('step-block__item--frequency-custom') &&
            block.classList.contains('step-block__item--active') &&
            this.dataset.layout === 'quiz') {
          return
        }
        this.clickedBlock = block
        this.previousStepButton?.classList.add('active');
        this.highlightBlock(event)
      })
    })

    this.stepInputs.forEach(input => {
      input.addEventListener('change', () => {
        this.selectStepBlock(input.closest('[data-step]'))
      })
      input.addEventListener('keydown', (event) => {
        const block = input.closest('[data-step]')
        if (event.key !== 'Enter' || event.repeat) return

        event.preventDefault()
        this.selectStepBlock(block)

        if (block.classList.contains('step-block__item--frequency-custom')) {
          this.showCustomFrequency()
          return
        }

        this.highlightBlock(event)
      })
    })

    this.customFrequencyButtons.forEach(button => {
      button.addEventListener('click', (event) => this.changeCustomQuantity(button, event))
    })

    this.customFrequency?.addEventListener('click', (event) => {
      if (event.detail === 0) return
      this.showCustomFrequency()
    })

    this.customFrequency?.addEventListener('keydown', (event) => {
      if (!this.customFrequency.classList.contains('step-block__item--custom-open')) return
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return

      event.preventDefault()
      const buttonSelector = event.key === 'ArrowRight' ? '.frequency-custom__plus' : '.frequency-custom__minus'
      const button = this.customFrequency.querySelector(buttonSelector)
      if (button) this.changeCustomQuantity(button, event)
    })

    this.addButtons.forEach(button => {
      button.addEventListener('click', this.clearCartAndAddToCart.bind(this))
    })
  }

  changeCustomQuantity(button, event) {
    event.stopPropagation();
    let customFrequency = button.closest('.step-block__item--frequency-custom')
    let customNumbers = customFrequency.querySelector('.frequency-custom__input').dataset.freq.split(',')
    let customFrequencyMin = Number(customNumbers[0])
    let customFrequencyMax = Number(customNumbers[customNumbers.length - 1])
    let currentFrequency = Number(customFrequency.dataset.frequency)
    let newFrequency = 0
    if (button.classList.contains('frequency-custom__plus')) {
      newFrequency = currentFrequency + 1
    } else {
      newFrequency = currentFrequency - 1
    }
    if(newFrequency < customFrequencyMin || newFrequency > customFrequencyMax) return;
    customFrequency.dataset.frequencyNumber = newFrequency
    customFrequency.dataset.frequency = newFrequency
    customFrequency.querySelector('.frequency-custom__input span').innerHTML = newFrequency
  }


  showCustomFrequency() {
    this.customFrequency.classList.add('step-block__item--custom-open')
    this.customFrequency.closest('.step-block__list').querySelectorAll('.step-block__item').forEach(frequencyBlock => {
      frequencyBlock.classList.toggle('step-block__item--frequency-hidden', frequencyBlock != this.customFrequency ? true : false)
    })
  }

  clearCart() {
    return fetch('/cart/clear.js')
  }

  clearCartAndAddToCart(event) {
    event.preventDefault()
    event.stopPropagation()
    this.clearCart()
      .then(() => {
        this.addToCart()
      })
  }

  selectStepBlock(block) {
    if (!block) return

    const currentStep = block.dataset.step
    this.querySelector(`[data-step="${currentStep}"].step-block__item--active`)?.classList.remove('step-block__item--active')
    const input = block.querySelector('.step-block__choice')
    if (input) input.checked = true
    block.classList.add('step-block__item--active')
    this.clickedBlock = block
  }

  highlightBlock(event) {
    let currentStep = this.clickedBlock.dataset.step
    let prevActiveBlock = this.querySelector(`[data-step="${currentStep}"].step-block__item--active`)
    if (prevActiveBlock) {
      prevActiveBlock.classList.remove('step-block__item--active')
    }
    this.clickedBlock.classList.add('step-block__item--active')
    this.openNextStep(event)
  }

  openNextStep(event) {
    const isKeyboardInteraction = event instanceof KeyboardEvent || event?.detail === 0

    if (+this.clickedBlock.dataset.step == 1) {
      this.productType = this.clickedBlock.dataset.type
      this.updateNextSteps(this.productType)
      this.hideProduct()
    }
    let nextStep = +this.clickedBlock.dataset.step + 1
    let nextStepWrapper = this.querySelector(`[data-step="${nextStep}"]`)
    if (this.isProductVisible) this.showProduct();
    if (nextStepWrapper) {
      this.setAttribute('data-current-step', +nextStep);
      this.showBlocksForCurrentType(nextStepWrapper)
      nextStepWrapper.closest('.step-block').classList.add('step-block--active')
      if (isKeyboardInteraction) {
        requestAnimationFrame(() => {
          nextStepWrapper.closest('.step-block').querySelector(
            '.step-block__item--visible .step-block__choice:not(:disabled), .step-block__item--frequency .step-block__choice:not(:disabled)'
          )?.focus()
        })
      }
      if (!this.isProductVisible && this.layout === 'quiz') {
        setTimeout(() => {
          const element = this.stepsProgress;
          let offset = 100;
          if(window.innerWidth < 750) {
            offset = 61;
          }

          const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
          const scrollTo = elementTop - offset;

          window.scrollTo({
            top: scrollTo,
            behavior: 'smooth'
          });
        }, 300);
      } else if (!this.isProductVisible && this.layout !== 'quiz') {
        setTimeout(() => {
          nextStepWrapper.closest('.step-block').scrollIntoView({ block: "center", behavior: "smooth" })
        }, 300);
      }
    } else {
      this.showProduct(event)
      if (isKeyboardInteraction) {
        requestAnimationFrame(() => {
          this.querySelector('.final-step__product--active .final-step__product__button')?.focus()
        })
      }
    }
  }

  updateNextSteps() {
    this.querySelectorAll('.step-block').forEach(step => {
      if (!step.classList.contains('step-block--default')) {
        step.classList.remove('step-block--active')
        step.querySelectorAll('[data-step]').forEach(stepBlock => {
          stepBlock.classList.remove('step-block__item--active')
        })
        step.querySelectorAll('.step-block__choice').forEach(input => {
          input.checked = false
        })
      }
    })
    this.querySelectorAll('.step-block__item--frequency-hidden').forEach(frequency => {
      frequency.classList.remove('step-block__item--frequency-hidden')
    })
    this.customFrequency?.classList.remove('step-block__item--custom-open')
  }

  showBlocksForCurrentType(nextStepWrapper) {
    nextStepWrapper.closest('.step-block').querySelectorAll('[data-type]').forEach(el => {
      el.classList.toggle('step-block__item--visible', el.dataset.type == this.productType ? true : false)
    })
  }

  hideProduct() {
    this.isProductVisible = false
    this.productBlock.classList.remove('active')
  }

  showProduct(event) {
    this.setAttribute('data-current-step', 'final');

    this.isProductVisible = true
    let productIdToShow = this.querySelector('.step-block__item--active[data-step="2"]').dataset.product
    let productItem = this.querySelector(`[data-id="${productIdToShow}"]`)
    let prevProduct = this.querySelector('.final-step__product--active')
    if (prevProduct && prevProduct != productItem) {
      prevProduct.classList.remove('final-step__product--active')
    }
    productItem.classList.add('final-step__product--active')
    this.updateProductInfo()
    this.productBlock.classList.add('active')
    if (event &&
        !event.target.classList.contains('apply-button') &&
        this.stepsProgress &&
        this.layout === 'quiz') {
      setTimeout(() => {
        const element = this.stepsProgress;
        let offset = 100;
        if(window.innerWidth < 750) {
          offset = 61;
        }

        const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
        const scrollTo = elementTop - offset;

        window.scrollTo({
          top: scrollTo,
          behavior: 'smooth'
        });
      }, 300);
    } else if (event && !event.target.classList.contains('step-block__item--frequency-custom') && this.layout !== 'quiz') {
      setTimeout(() => {
        this.productBlock.scrollIntoView({ block: "center", behavior: "smooth" })
      }, 300);
    }
  }

  getCurrentDiscountedPrice(product, subscriptionQuantity, customDiscount) {
    const prices = this.purchaseType == 'subscription' ? product.subscription_prices : product.onetime_prices;
    if (!prices) return 0;

    const maxVolumeQuantity = prices[prices.length - 1].split('--')[0].replace('+', '');

    const discountPerItem = prices.find((value) => {
      const quantity = value.split('--')[0].replace('+', '');
      return +quantity === subscriptionQuantity || +quantity === +maxVolumeQuantity;
    })?.split('--')[1];

    if (customDiscount) {
      const { code, packs, default_price, percentage } = product.discount;
      const hasCustomDiscount = code && packs.includes(subscriptionQuantity.toString());
      
      if (hasCustomDiscount) {
        const customDiscountPerItem = default_price - (default_price * (percentage / 100));
        return Math.round(customDiscountPerItem);
      }
    }

    return Math.round(discountPerItem * 100);
  }

  updateProductInfo() {
    const variantEl = this.querySelector('.step-block__item--active[data-variant]');
    const productEl = this.querySelector('.step-block__item--active[data-product]');
    const quantityEl = this.querySelector('.step-block__item--active[data-quantity]');
    const frequencyEl = this.querySelector('.step-block__item--active[data-frequency]');
  
    if (!variantEl || !productEl || !quantityEl) return;
  
    const variant =
      variantEl.dataset.variant === 'pods'
        ? 'Default Title'
        : variantEl.dataset.variant || 'Default Title';
  
    const productId = productEl.dataset.product;
    const quantity = parseInt(quantityEl.dataset.quantity || 1, 10);
    const frequencyNumber = frequencyEl?.dataset.frequencyNumber || null;
  
    const product = this.productsObject[productId];
    if (!product) return;

    const customDiscount = product.discount || false;
    const discountedPrice = this.getCurrentDiscountedPrice(product, quantity, customDiscount);
    const totalPrice = ((discountedPrice * quantity) / 100).toFixed(2);
    const priceText = `${window.currencySymbol}${totalPrice}`;
  
    this.selectedProduct = product;
    this.selectedProduct.has_custom_discount = this.selectedProduct.discount?.packs?.includes(quantity.toString());

    if (this.selectedProduct.has_custom_discount) {
      const defaultPrice = this.getCurrentDiscountedPrice(product, quantity, false);
      const defaultTotalPrice = ((defaultPrice * quantity) / 100).toFixed(2);
      const defaultDiscountPercentage = Math.round((product.discount.default_price - defaultPrice) * 100 / product.discount.default_price)

      const currentPercentageElement = this.querySelector('.final-step__product--active .custom-discount__percentage--current');
      const originalPercentageElement = this.querySelector('.final-step__product--active .custom-discount__percentage--regular');
      const originalPriceElement = this.querySelector('.final-step__product--active .custom-discount__price--regular');

      const setInnerText = (element, text) => {
        if (!element) return;
        element.innerText = text;
      }

      setInnerText(currentPercentageElement, `${this.selectedProduct.discount.percentage}%`);
      setInnerText(originalPercentageElement, `${defaultDiscountPercentage}%`);
      setInnerText(originalPriceElement, `${window.currencySymbol}${defaultTotalPrice}`);
    }

    this.querySelector('.final-step__product--active').classList.toggle('final-step__product--has-custom-discount', this.selectedProduct.has_custom_discount);
  
    const subscriptionEl = this.querySelector('.final-step__product__subscribtion');
    const frequencyInfo = subscriptionEl?.dataset.info?.replace('[n]', frequencyNumber) || '';
  
    if (this.purchaseType === 'subscription') {
      const subTextEl = this.querySelector('.final-step__product--active .final-step__product__subscribtion span');
      if (subTextEl) {
        subTextEl.innerHTML = `${quantity} ${this.productType} ${frequencyInfo} | ${variant}`;
      }
    }
  
    this.querySelector('.final-step__product--active .final-step__product__button span')?.replaceChildren(priceText);
    this.querySelector('.final-step__product--active .final-step__product__price')?.replaceChildren(priceText);
  
    this.setKlaviyoItems(this.selectedProduct, quantity, totalPrice);
    if (typeof klaviyoItem !== 'undefined') klaviyo.push(['track', 'Viewed Product', klaviyoItem]);
    if (typeof trackViewedItem !== 'undefined') klaviyo.push(['trackViewedItem', trackViewedItem]);
  }
  
  

  setKlaviyoItems(product, currentProductQuantity, productPrice) {
    window.klaviyoItem = {
      Name: product.title,
      ProductID: product.id,
      Categories: product.title,
      ImageURL: product.featured_image,
      URL: `${window.location.origin}/products/${product.handle}`,
      Brand: product.vendor,
      Price: window.theme.moneyFormat?.replace('{{amount}}', productPrice),
      CompareAtPrice: window.theme.moneyFormat?.replace('{{amount}}', (product.compare_at_price_max * +currentProductQuantity) / 100)
    }

    window.trackViewedItem = {
      Title: klaviyoItem.Name,
      ItemId: klaviyoItem.ProductID,
      Categories: klaviyoItem.Categories,
      ImageUrl: klaviyoItem.ImageURL,
      Url: klaviyoItem.URL,
      Metadata: {
        Brand: klaviyoItem.Brand,
        Price: klaviyoItem.Price,
        CompareAtPrice: klaviyoItem.CompareAtPrice
      }
    }
  }

  addToCart() {
    let selectedVariantId
    if (this.selectedProduct.variants.length == 1) {
      selectedVariantId = this.selectedProduct.variants[0].id
    } else {
      let variantTitle = this.querySelector('.step-block__item--active[data-variant]') == 'pods' ? 'Default Title' : this.querySelector('.step-block__item--active[data-variant]').dataset.variant
      for (let i = 0; i < this.selectedProduct.variants.length; i++) {
        if (variantTitle == this.selectedProduct.variants[i].title) {
          selectedVariantId = this.selectedProduct.variants[i].id
          break;
        }
      }
    }
    let frequencyName = this.querySelector('.step-block__item--active[data-frequency]')?.closest('.step-block')?.dataset.trueName || null;
    let subscriptionName = frequencyName?.replace('[n]', this.querySelector('.step-block__item--active[data-frequency]').dataset.frequencyNumber) || null;
    let atcObject = {
      'items': [{
        'id': Number(selectedVariantId),
        'quantity': Number(this.querySelector('.step-block__item--active[data-quantity]').dataset.quantity)
      }]
    };
    if (this.purchaseType == 'subscription') {
      let subscriptionGroups = this.selectedProduct.selling_plan_groups[0].selling_plans
      for (let i = 0; i < subscriptionGroups.length; i++) {
        if (subscriptionGroups[i].name == subscriptionName) {
          atcObject.items[0].selling_plan = subscriptionGroups[i].id
          break
        }
      }
    }
    if(localStorage.getItem('first-visited-page')){
      atcObject.items[0].properties = atcObject.items[0].properties || {};
      atcObject.items[0].properties['_first_visited_page'] = localStorage.getItem('first-visited-page');
    }

    if (typeof klaviyoItem != 'undefined') klaviyo.push(['track', 'Added to Cart', klaviyoItem]);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(atcObject)
    })
    .then(() => {
      window.location.href = '/checkout?discount=' + (this.selectedProduct.has_custom_discount && this.selectedProduct.discount ? this.selectedProduct.discount.code : '');
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

customElements.define('landing-product', LandingSubscription)

class LandingSubscriptionV2 extends LandingSubscription {
  constructor() {
    super();

    this.previousStepButton = this.querySelector('.landing-product__previous-step-button')
    this.stepBlocksContainer = this.querySelector('.landing-product__steps-container')

    this.previousStepButton.addEventListener('click', (event) => {
      this.closeCurrentStep();

      if (event.detail === 0) {
        requestAnimationFrame(() => {
          const activeStep = this.querySelector('.landing-product__step.step-block--active')
          const selectedChoice = activeStep?.querySelector('.step-block__choice:checked')
          const firstChoice = activeStep?.querySelector(
            '.step-block__item--visible .step-block__choice:not(:disabled), .step-block__item--frequency .step-block__choice:not(:disabled)'
          )
          const choiceToFocus = selectedChoice || firstChoice
          choiceToFocus?.focus()
        })
      }
    })
  }

  highlightBlock(event) {
    let currentStep = this.clickedBlock.dataset.step
    let prevActiveBlock = this.querySelector(`[data-step="${currentStep}"].step-block__item--active`)
    let isClickedBlockActive = this.clickedBlock.classList.contains('step-block__item--active')
    if (prevActiveBlock) {
      prevActiveBlock.classList.remove('step-block__item--active')
    }
    this.clickedBlock.classList.add('step-block__item--active')

    if (this.layout == 'quiz' && this.clickedBlock == this.customFrequency && !isClickedBlockActive) {
      return
    }
    this.handleChangeProductImages(currentStep);
    this.openNextStep(event)
  }

  handleChangeProductImages(currentStep) {
    let currentType = this.clickedBlock.dataset.type;

    if (+currentStep === 2) {
      let productId = this.clickedBlock.dataset.product;
      let currentProduct = this.productsObject[productId];
      this.changeQuantityImages(currentProduct, currentType);
    } else if (+currentStep === 3) {
      let productId = this.querySelector('.step-block__item--active[data-step="2"]').dataset.product
      let currentQuantity = this.clickedBlock.dataset.quantity;
      this.changeProductImage(productId, currentQuantity);
    }
  }

  changeQuantityImages(currentProduct, currentType) {
    const currentQuantityBlocks = this.querySelectorAll(`[data-type="${currentType}"][data-step="3"]`);
    const image_1_url = currentProduct.pack_1_image;
    const image_2_url = currentProduct.pack_2_image;
    const image_3_url = currentProduct.pack_3_image;
    const image_4_url = currentProduct.pack_4_image;
    const image_6_url = currentProduct.pack_6_image;

    currentQuantityBlocks.forEach(quantityBlock => {
      const quantity = +quantityBlock.dataset.quantity;
      const image = quantityBlock.querySelector('.step-block__item__icon img');

      switch (quantity) {
        case 1:
          image_1_url ? image.src = image_1_url : null;
          break;
        case 2:
          image_2_url ? image.src = image_2_url : null;
          break;
        case 3:
          image_3_url ? image.src = image_3_url : null;
          break;
        case 4:
          image_4_url ? image.src = image_4_url : null;
          break;
        case 6:
          image_6_url ? image.src = image_6_url : null;
          break;
      }
    })
  }

  changeProductImage(productId, currentQuantity) {
    let currentProduct = this.productsObject[productId];
    let productItem = this.querySelector(`[data-id="${productId}"]`);
    let productImage = productItem.querySelector('.final-step__product__image-wrapper img');
    const defaultImageUrl = currentProduct.featured_image;
    const defaultImageSrcset = currentProduct.featured_image + `&width=1200 1200w`;
    const image_2_url = currentProduct.pack_2_image;
    const image_2_srcset = image_2_url + `&width=1200 1200w`
    const image_3_url = currentProduct.pack_3_image;
    const image_3_srcset = image_3_url + `&width=1200 1200w`
    const image_4_url = currentProduct.pack_4_image;
    const image_4_srcset = image_4_url + `&width=1200 1200w`
    const image_6_url = currentProduct.pack_6_image;
    const image_6_srcset = image_6_url + `&width=1200 1200w`

    switch (+currentQuantity) {
      case 2:
        image_2_url ? productImage.src = image_2_url : productImage.src = defaultImageUrl;
        image_2_url ? productImage.setAttribute('srcset',image_2_srcset ) : productImage.setAttribute('srcset',defaultImageSrcset);
        break;
      case 3:
        image_3_url ? productImage.src = image_3_url : productImage.src = defaultImageUrl;
        image_3_url ? productImage.setAttribute('srcset', image_3_srcset) : productImage.setAttribute('srcset',defaultImageSrcset);
        break;
      case 4:
        image_4_url ? productImage.src = image_4_url : productImage.src = defaultImageUrl;
        image_4_url ? productImage.setAttribute('srcset', image_4_srcset) : productImage.setAttribute('srcset',defaultImageSrcset);
        break;
      case 6:
        image_6_url ? productImage.src = image_6_url : defaultImproductImage.src = defaultImageUrlageUrl;
        image_6_url ? productImage.setAttribute('srcset', image_6_srcset) : productImage.setAttribute('srcset',defaultImageSrcset);
        break;
    }
  }

  closeCurrentStep() {
    if (this.dataset.currentStep == 'final') {
      this.dataset.currentStep = this.clickedBlock.dataset.step;
      this.querySelector('.landing-product__final').classList.remove('active');
    } else {
      let currentStepWrapper = this.querySelector(`[data-step="${this.dataset.currentStep}"]`);
      this.dataset.currentStep == 2 ? this.previousStepButton.classList.remove('active') : null;
      currentStepWrapper?.closest('.landing-product__step').classList.remove('step-block--active');
      this.dataset.currentStep = Math.max(this.dataset.currentStep - 1, 1);
    }
  }

  static get observedAttributes() {
    return ["data-current-step"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-current-step") {
      this.handleStepChange(newValue);
    }
  }

  handleStepChange(newStep) {
    let allSteps = this.querySelectorAll('.landing-product__step');
    let finalStep = this.querySelector('.landing-product__final');
    let currentStep = this.querySelector(`[data-step="${newStep}"]`)?.closest('.landing-product__step');

    if (newStep == 'final') {
      allSteps.forEach(step =>  {
        step.classList.remove('step-block--active')
      });
      finalStep.classList.add('active');
    } else {
      allSteps.forEach(step => step.classList.remove('step-block--active'));
      finalStep.classList.remove('active');
      currentStep.classList.add('step-block--active');
    }

    this.updateStepsProgress(newStep);
  }

  updateStepsProgress(currentStepIndex) {
    const steps = document.querySelectorAll(".step-progress");

    if (currentStepIndex == 'final') {
      steps.forEach(step => {
        step.classList.add("completed");
      });
      return;
    }

    steps.forEach((step, index) => {
      if (index < currentStepIndex - 1) {
        step.classList.add("completed");
        step.classList.remove("active");
      } else if (index === currentStepIndex) {
        step.classList.add("active");
        step.classList.remove("completed");
      } else {
        step.classList.remove("active", "completed");
      }
    });
  }
}

customElements.define('landing-product-v2', LandingSubscriptionV2);
